import React from "react";
import { Box, CardHeader, Avatar, Typography, IconButton, Tooltip } from "@mui/material";
import CollectionsIcon from "@mui/icons-material/Collections";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/material/styles";

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  padding: "12px 16px 8px 16px",
  background: "rgba(255,255,255,0.6)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  borderBottom: "none",
  "& .MuiCardHeader-title": {
    width: "100%",
  },
}));

const UserNameBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  padding: "4px 8px",
  borderRadius: "8px",
  background: "rgba(139,92,246,0.05)",
  border: "1px solid rgba(139,92,246,0.1)",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    background: "rgba(139,92,246,0.1)",
    borderColor: "rgba(139,92,246,0.2)",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 12px rgba(139,92,246,0.15)",
  },
  "& label": {
    fontSize: "12px",
    fontWeight: 600,
    color: "rgba(30,41,59,0.9)",
  },
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: "28px",
  height: "28px",
  marginRight: "8px",
  border: "2px solid rgba(255,255,255,0.9)",
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  background: "linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 4px 12px rgba(139,92,246,0.3)",
  },
}));

const CollectionCardHeader = ({
  data,
  onUserClick,
  onViewCollection,
}) => {
  const getColorForCollection = (data) => {
    const colors = [
      "#6366f1", // Indigo
      "#8b5cf6", // Violet
      "#06b6d4", // Cyan
      "#10b981", // Emerald
      "#f59e0b", // Amber
      "#ef4444", // Red
    ];

    const name = data?.name || "";
    const firstLetter = name[0]?.toLowerCase() || "a";
    return colors[firstLetter.charCodeAt(0) % colors.length];
  };

  const color = getColorForCollection(data);

  return (
    <StyledCardHeader
      title={
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            {/* Empty - user info is now on the image */}
          </Box>
        </Box>
      }
    />
  );
};

export default CollectionCardHeader;
